/**
 * @file jobSearch.ts
 *
 * @fileoverview Provides job search query.
 */

import { gql } from '@apollo/client';
import CUSTOM_FIELDS from '~/graphql/queries/job/customJobFields.gql';
import { getJobTeaserFragment } from '~/jobiqo/components/Job/graphql/fragments/jobTeaserFragment';
import FACET_VALUE_FRAGMENT from '~/jobiqo/graphql/fragments/facetFragment.gql';

export const jobSearchQuery = (WATCHADO_ENABLED?: boolean) => gql`
  ${CUSTOM_FIELDS}
  ${getJobTeaserFragment(undefined)}
  ${FACET_VALUE_FRAGMENT}
  query solrSearch(
    $range: RangeInput!
    $sorts: [SortInput]
    $language: String!
    $condition_group: ConditionGroupInput!
    $fulltext: FulltextInput!
    $facets: [FacetInput]!
    $geoLocation: GeoInput
    $searchPath: String!
  ) {
    jobs(
      ranges: $range
      sorts: $sorts
      language: [$language]
      condition_group: $condition_group
      fulltext: $fulltext
      facets: $facets
      geo_input: $geoLocation
      search_path: $searchPath
    ) {
      result_count
      seoSearchContent {
        title
        subtitle
        footer
        footerFormat
        headerImage(style: "banner_desktop") {
          url
          alt
          title
          caption
        }
        shareImage(style: "og_image") {
          url
          alt
          title
          caption
        }
      }
      metatags {
        meta
        value
      }
      faq {
        question
        answer
      }
      ${WATCHADO_ENABLED ? 'watchadoJobIds' : ''}
      pages {
        ... on Job {
          ...JobTeaserFragment
          ...CustomFields
        }
      }
      backfill {
        title
        organization
      }
      facets {
        name
        values {
          ...FacetValueFragment
          children {
            ...FacetValueFragment
            children {
              ...FacetValueFragment
              aliasTranslation {
                langcode
                alias
              }
            }
            aliasTranslation {
              langcode
              alias
            }
          }
          aliasTranslation {
            langcode
            alias
          }
        }
      }
      radius_search
    }
  }
`;
